import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { fetchCurrentUser } from "../../utils/auth";
import { toast } from "react-toastify";
import { MdBlock } from "react-icons/md";

export default function ProtectedRoute({ allowedRoles, children }) {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    async function loadUser() {
      const user = await fetchCurrentUser();
      setCurrentUser(user);
      setLoading(false);

      if (!user?.loggedIn) {
        toast.info("Please login to continue");
      }
    }
    loadUser();
  }, []);

  if (loading) {
    return <p className="text-center mt-20 text-gray-500">Loading...</p>;
  }

  // Not logged in → redirect to home
  if (!currentUser?.loggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const userRole = parseInt(currentUser.role_id);
  const allowed = allowedRoles.map((r) => parseInt(r));

  // Role 1 (customer) trying to access role 2 or 3 → redirect to "/"
  if (userRole === 1 && allowed.some((r) => r === 2 || r === 3)) {
    return <Navigate to="/" replace />;
  }

  // Role 3 trying to access role 2 → show Access Denied
  if (userRole === 3 && allowed.includes(2)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
        <MdBlock className="text-red-500" size={60} />
        <h1 className="mt-4 text-3xl font-bold text-red-600">Access Denied</h1>
        <p className="mt-2 text-gray-700 max-w-md text-center">
          You do not have permission to view this page. If you think this is a
          mistake, please contact the administrator.
        </p>
      </div>
    );
  }

  // Other disallowed role → go to login
  if (!allowed.includes(userRole)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
